import { render } from "./AnimatedDots.vue?vue&type=template&id=085650b8&scoped=true"
const script = {}

import "./AnimatedDots.vue?vue&type=style&index=0&id=085650b8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085650b8"]])

export default __exports__